import { type FC, useMemo } from 'react'
import { useSharedUserOptions } from '../../../../common/useSharedUsers'
import { SelectDropdown, type SelectOption } from '../../../../components/SelectDropdown/SelectDropdown'
import { type User } from '../../../../models/User'

interface OwnerSelectProps {
  onOwnerChange: (owner: User) => void
  disabled?: boolean
}

export const OwnerSelect: FC<OwnerSelectProps> = ({ onOwnerChange, disabled }) => {
  const { options, currentUser, toOption, findUser, loading, onSearchInputChange } = useSharedUserOptions({ shareType: 'scheduling' })

  const handleOptionSelected = (option: SelectOption) => {
    const user = findUser(option)
    if (user == null) {
      return
    }
    onOwnerChange(user)
  }

  const selected = useMemo(() => toOption(currentUser), [currentUser, toOption])

  return (
    <div className='d-flex flex-column zocks-gap-0.25'>
      <label className='bold'>Owner</label>
      <div className='paragraph-small zocks-text-gray-600'>Whose calendar we book into</div>
      <SelectDropdown
        options={options}
        initialSelectedOption={selected}
        placeholder='Search team members'
        searchable
        loading={loading}
        inputAutoComplete='off'
        onSearchInputChange={onSearchInputChange}
        onOptionSelected={handleOptionSelected}
        disabled={disabled}
      />
    </div>
  )
}
